import React, {useState, useRef} from 'react';
import {Link} from "react-router-dom";
import tw from 'twin.macro';

const Div = tw.div`flex justify-center items-center md:h-screen`;
const DivFlex = tw.div`mx-4 md:mx-20 max-w-screen-xl min-h-screen text-center bg-gray-200 py-10 px-5 lg:px-0 lg:px-10 rounded-sm`;
const FlexDiv = tw.div`mt-4`;
const Text = tw.text` text-xl text-center w-full  font-bold text-gray-700`;
const Span = tw.text`text-yellow-600`;
const TextBold = tw.div`font-semibold md:truncate text-gray-900`;
const Flex = tw.div`flex mt-1`;
const P = tw.div`mx-2 text-justify text-gray-800`;
const LinkTitle = tw.text`mr-2 text-justify`;
const SpanPx = tw.span`mx-2 `;

const siteMap = [
  {
    title: "Home",
    para: 'List of the top trailers , latest news, latest movies, latest actor and actress images',
    link:"https://flexposters.com"
  },
  {
    title: "Contact us",
    para: 'Contact information to reach us for better Communication',
    link:"https://flexposters.com/contactUs"
  },
  {
    title: "Movie",
    para: 'All recent movie are appear in top of the list ',
    link:"https://flexposters.com/movie"
  },
  {
    title: "News",
    para: 'All sort of news from Press release to Happenings in All Film industry is covered under this section .Shorted by recent Date',
    link:"https://flexposters.com/news"
  },
  {
    title: "Privacy policy",
    para: 'Our terms conditions and privacy policy of flexposters.com under which we provide service',
    link:"https://flexposters.com/privacy_policy"
  },
  {
    title: "Trailer",
    para: 'List of Recently Added Trailer shored by recently added',
    link:"https://flexposters.com/trailer"
  },
  {
    title: "Actor Image",
    para: 'List of Recently Added Images shored by recently added',
    link:"https://flexposters.com/actors"
  },
  {
    title: "actress Image",
    para: 'List of Recently Added Images shored by recently added',
    link:"https://flexposters.com/actress"
  },

]


function SiteMap() {
  return (
    <Div>
      <DivFlex>
        <Text><Span>FLEX</Span> POSTER<SpanPx>SiteMap</SpanPx></Text>
        <div >
          {siteMap.map(item => (
            <Content link={item.link} title={item.title} para={item.para}/>
          ))}
       
        </div>
      </DivFlex>
    </Div>
  )
}

export default SiteMap;


export const Content = ({link, title,para}) => (
  <FlexDiv>
    <Flex>
      <TextBold>{title}:</TextBold>
      <P>{para}</P>
    </Flex>
    <Flex>

      <LinkTitle>Link :</LinkTitle>
      <Link to={link}>{link}</Link>
    </Flex>
    
  </FlexDiv>
)